exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#grid[data-v-7d50f586]{display:grid;height:100vh;grid-template-columns:71px 240px auto 240px;grid-template-rows:46px auto 52px;grid-template-areas:\"SL SN CI CI\" \"SL CL CD UL\" \"SL UI CD UL\"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7d50f586","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Layout.vue
// module id = 36
// module chunks = 0